export class EoTrackerUpdate {
  id: number;
  projectId: number;
  enteredAt: Date;
  enteredBy: string;
  updateContent: string;
}
